export default {
  lista: [],
  estaCarregando: false,
  paginaAtual: 1,
  totalItens: null,
  todosItensCarregados: false,
  itemSelecionado: {
    data_inicial_entrada: '',
    data_final_entrada: '',
    data_inicial_bom_para: '',
    data_final_bom_para: '',
    data_inicial_baixa: '',
    data_final_baixa: '',
    data_inicial_devolucao: '',
    data_final_devolucao: '',
    motivo_devolucao: '',
    conta: '',
    plano_conta: '',
    situacao: null,
    tipo: null,
    detalhado: false,
    agrupadoBanco: false,
    excel: false
  }
}
